import { v4 as uuid } from 'uuid';

const STORAGE_KEY = 'VirtualCardOrderIdentifier';

export const useVirtualCardOrderIdentifier = () => {
  return {
    getCurrent(): string {
      let currentKey = localStorage.getItem(STORAGE_KEY);
      if (!currentKey) {
        currentKey = uuid();
        localStorage.setItem(STORAGE_KEY, currentKey);
      }
      return currentKey;
    },
    orderSucceeded(): void {
      localStorage.removeItem(STORAGE_KEY);
    },
  };
};
